import service from "../services/attendance.service";

export const attendance = {
    namespaced: true,
    actions: {
        async getDay(context, params) {
            try {
                const response = await service.getDay(params);
                return response.data;
            } catch (error) {
                console.error("Error fetching attendance:", error);
                throw error.response;
            }
        },
        async saveDay(context, data) {
            try {
                return await service.saveDay(data);
            } catch (error) {
                console.error("Error saving attendance:", error);
                return error.response;
            }
        },
        async getSummary(context, params) {
            try {
                const response = await service.getSummary(params);
                return response.data;
            } catch (error) {
                console.error("Error fetching attendance summary:", error);
                throw error.response;
            }
        },
        async getPendingDeductions(context, userId) {
            try {
                const response = await service.getPendingDeductions(userId);
                return response.data;
            } catch (error) {
                console.error("Error fetching pending deductions:", error);
                throw error.response;
            }
        },
        async getUserHistory(context, { userId, ...params }) {
            try {
                const response = await service.getUserHistory(userId, params);
                return response.data;
            } catch (error) {
                console.error("Error fetching attendance history:", error);
                throw error.response;
            }
        },
    },
};
